var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgProfileFeedbackError = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M31.273 33.889c0 8.745 7.157 15.843 15.933 15.843 8.777 0 15.916-7.116 15.933-15.843v-9.046C63.14 16.1 55.983 9 47.206 9c-8.794 0-15.933 7.099-15.933 15.843v9.046Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M35.96 35.514c0 7.266 5.752 13.164 12.805 13.164s12.79-5.913 12.804-13.164V28c0-7.266-5.751-13.164-12.804-13.164-7.068 0-12.805 5.898-12.805 13.164v7.515Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M62.305 34.485c0 4.662-1.535 8.336-4.162 10.847-2.631 2.514-6.431 3.932-11.087 3.932s-8.399-1.417-10.975-3.927c-2.573-2.508-4.06-6.183-4.06-10.852 0-1.115-.052-2.858-.105-4.604l-.002-.08c-.054-1.784-.107-3.565-.107-4.727 0-9.85 8.179-15.25 15.249-15.25s15.249 5.4 15.249 15.25v9.411Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M19.567 78.428c5.999 3.151 16.364 6.656 27.49 6.656 11.126 0 21.808-3.505 27.807-6.656a6.521 6.521 0 0 0 3.507-5.417c.499-8.125-2.225-12.285-4.61-14.338-1.14-.992-2.6-1.7-4.433-2.142-6.231-1.487-12.318-5.972-12.39-6.042-6.587 3.757-13.646 3.286-20.233-.008-8.47 5.647-7.304 5.024-11.602 6.05-1.834.442-3.293 1.15-4.433 2.142-2.385 2.053-5.109 6.213-4.61 14.338a6.52 6.52 0 0 0 3.507 5.417Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M36.705 50.481c-.072.071-5.371 4.556-11.602 6.043-1.834.442-3.293 1.15-4.433 2.142-2.385 2.053-5.109 6.213-4.61 14.338.142 2.301 1.64 4.631 3.705 5.71 5.999 3.152 16.166 6.363 27.292 6.363 11.126 0 21.764-3.211 27.763-6.362 2.065-1.08 3.409-3.41 3.551-5.71.499-8.126-2.225-12.286-4.61-14.34-1.14-.99-2.6-1.699-4.433-2.141-6.231-1.487-12.318-5.972-12.39-6.043"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M72.304 86.61C79.868 86.61 86 80.476 86 72.912c0-7.563-6.132-13.695-13.696-13.695S58.608 65.35 58.608 72.913c0 7.564 6.132 13.696 13.696 13.696Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M68.171 68.768a1.125 1.125 0 0 1 1.62 0l7.128 7.313a1.197 1.197 0 0 1 0 1.662 1.125 1.125 0 0 1-1.62 0l-7.128-7.313a1.197 1.197 0 0 1 0-1.662Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M68.496 77.744a1.197 1.197 0 0 1 0-1.662l7.128-7.314a1.125 1.125 0 0 1 1.62 0 1.197 1.197 0 0 1 0 1.662l-7.128 7.314a1.125 1.125 0 0 1-1.62 0Z",
    clipRule: "evenodd"
  }));
};
export default SvgProfileFeedbackError;